// extracted by mini-css-extract-plugin
export default {"columnHeading":"styles_columnHeading__Jfeki"};